import { z } from "zod";

const phone = z.string().min(11, "Número invalido").max(15, "Número invalido");

export const defaultSchemes = {
  phone,
};
